import { resolveScheduleType } from "../utils/scheduleEditorMapping";
import { getScheduleDocumentType } from "./scheduleTaggingService";

export async function fetchSchedulesByType({
  tcId,
  detailsId,
  selectedScheduleType,
  companyType = "common",
  getPlScheduleByType,
  getCaScheduleByType,
}) {
  if (!selectedScheduleType || !getPlScheduleByType) return [];

  const schedules =
    selectedScheduleType === "FAAdditions"
      ? await getCaScheduleByType(tcId, "FAAdditions")
      : await getPlScheduleByType(
          tcId,
          resolveScheduleType(selectedScheduleType, companyType)
        );

  return Array.isArray(schedules)
    ? schedules.filter((schedule) => schedule.sch_id !== detailsId)
    : [];
}

export async function submitTaggingChange({
  data,
  reference,
  editMode,
  source,
  tagSchedule,
  unTagSchedule,
}) {
  if (editMode) {
    await unTagSchedule(
      source,
      reference.row.row_id,
      getScheduleDocumentType(reference.row.schedule.scheduleType),
      false
    );
  }

  const updatedRow = await tagSchedule(data, reference);

  if (!updatedRow) {
    throw new Error("Unknown error happens during processing your request.");
  }

  return updatedRow;
}

export async function submitScheduleCreation({
  data,
  reference,
  editMode,
  source,
  createTagSchedule,
  unTagSchedule,
}) {
  if (editMode) {
    await unTagSchedule(
      source,
      reference.row.row_id,
      getScheduleDocumentType(reference.row.schedule.scheduleType),
      false
    );
  }

  const updatedRow = await createTagSchedule(data, reference);

  if (!updatedRow) {
    throw new Error("Unknown error happens during processing your request.");
  }

  return updatedRow;
}
